import * as React from "react";
import { useAuth } from "../contexts/authContext";
import { useCheckTokenAndFetchUser } from "../hooks/useCheckTokenAndFetchUser";
import { SignIn } from "./SignIn";
import { useSession } from "../contexts/sessionContext";
import { useAudit } from "../contexts/auditSessionContext";
import { MemoryRouter, Routes, Route } from "react-router-dom";
import Taskpane from "../pages/Taskpane";
import SessionDialog from "../pages/SessionDialog";
import GoogleCallback from "../pages/GoogleCallback";
import { GoogleSignIn } from "../pages/GoogleDialog";
import { makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
});

const App: React.FC = () => {
  const styles = useStyles();
  const { auth, setAuth, loading: authLoading } = useAuth();
  const { user, workspace, loading, accessToken } = useCheckTokenAndFetchUser();
  const { sessionAttachment } = useSession();
  const { fetchAuditSession } = useAudit();

  React.useEffect(() => {
    if (sessionAttachment) {
      fetchAuditSession({ auditSessionId: sessionAttachment.sessionId });
    }
  }, [sessionAttachment]);

  React.useEffect(() => {
    if (loading) return;

    if (user && workspace) {
      setAuth({ user, loading: false, accessToken, workspace });
    } else if (user) {
      setAuth({ user, loading: false, accessToken, workspace: null });
    } else {
      setAuth({
        user: null,
        loading: false,
        accessToken: null,
        workspace: null,
      });
    }
  }, [user, setAuth, loading, accessToken, workspace]);

  if (authLoading || loading) {
    return <div className={styles.loading}>Loading...</div>;
  }

  return (
    <MemoryRouter initialEntries={[window.location.pathname]}>
      <Routes>
        <Route path="/signin" element={<SignIn />} />
        <Route path="/taskpane" element={<Taskpane />} />
        <Route path="/taskpane.html" element={<Taskpane />} />
        <Route path="/session-dialog" element={<SessionDialog />} />
        <Route path="/google-signin" element={<GoogleSignIn />} />
        <Route path="/google-callback.html" element={<GoogleCallback />} />
      </Routes>
    </MemoryRouter>
  );
};

export default App;
